import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { MatTooltipModule } from '@angular/material/tooltip';
import { DeleteWithTypeDialogService } from '@libs/shared/ui/dialogs/delete-with-type-dialog/delete-with-type-dialog.service';
import { DeleteWithTypeDialogComponent } from './delete-with-type-dialog.component';

@NgModule({
  declarations: [DeleteWithTypeDialogComponent],
  imports: [
    CommonModule,
    MatButtonModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    ReactiveFormsModule,
    MatCheckboxModule,
    MatRadioModule,
    MatIconModule,
    MatTooltipModule,
  ],
  providers: [DeleteWithTypeDialogService],
})
export class DeleteWithTypeDialogModule {
  constructor(
    private _deleteWithTypeDialogService: DeleteWithTypeDialogService
  ) {}
}
